export const PRIVACY_POLICY = 'https://www.bcdtravel.com/privacy-policy/';

export const TERMS_AND_CONDITION = 'https://www.bcdtravel.com/legal/';
